















































































































import Vue from 'vue'
import {
  makeSummary,
  analyseSentiment,
  Timeline,
  getTimeline
} from '../utils/analysis'
import { BUNNY_STORAGE } from '../utils/bunny-storage'

export default Vue.extend({
  name: 'Analyse',

  computed: {
    textToAnalyse(): string {
      return this.$route.params.textToAnalyse
    }
  },

  data() {
    const dialog = false
    const summaryInfo = {
      canSummarize: false,
      askForSummary: false,
      summary: ''
    }
    const sentimentInfo = {
      sentiment: 0
    }
    const timelineInfo = {
      timeline: [] as Timeline[]
    }
    return {
      dialog,
      ...summaryInfo,
      ...sentimentInfo,
      ...timelineInfo
    }
  },

  mounted() {
    if (!this.textToAnalyse || this.textToAnalyse.trim().length === 0) {
      if (this.$router.currentRoute.name === 'WriteText') {
        return
      }
      this.$router.push({
        name: 'WriteText'
      })
    } else {
      this.analyse()
    }
  },

  methods: {
    analyse() {
      this.summarize()
      this.analyseSentiment()
      this.makeTimeline()
    },
    makeTimeline() {
      this.timeline = getTimeline(this.textToAnalyse)
    },
    summarize() {
      this.summary = makeSummary(this.textToAnalyse)
      this.canSummarize = this.summary.length > 0
    },
    analyseSentiment() {
      this.sentiment = analyseSentiment(this.textToAnalyse)
    },
    save() {
      this.dialog = false
      const notes = localStorage.getItem(BUNNY_STORAGE)
        ? JSON.parse(localStorage.getItem(BUNNY_STORAGE)!)
        : []
      const newNote = {
        timeline: this.timeline,
        summary: this.summary,
        sentiment: this.sentiment,
        title: (this.$refs.fileName as any).internalValue
      }
      localStorage.setItem(BUNNY_STORAGE, JSON.stringify([...notes, newNote]))
      if (this.$router.currentRoute.name === 'Notes') {
        return
      }
      this.$router.push({
        name: 'Notes'
      })
    }
  }
})
